<!--sidebar-->

<c-sidebar
  [hidden]="!isSidebarVisible"
  #sidebar="cSidebar"
  class="d-print-none sidebar sidebar-fixed sidebar-narrow narrow"
  id="sidebar"
  visible [narrow]="isSidebarCollapsed" unfoldable
>
  <!--  'assets/img/portal/Tap-Logo-Horiz.png', -->
  <c-sidebar-brand
    [brandFull]="{
      src: 'assets/img/portal/tapestry-health-logo-horizontal.png',
      width: 240,
      alt: 'Portal Logo'
    }"
    [brandNarrow]="{
      src: 'assets/img/portal/TPHL-logo.png',
      width: 46,
      height: 46,
      alt: 'Portal Logo'
    }"
    routerLink="./"
  />

  <ng-scrollbar pointerEventsMethod="scrollbar">
    <c-sidebar-nav
      [navItems]="navItems"
      dropdownMode="close"
    />
  </ng-scrollbar>
  <c-sidebar-toggler
    toggle="unfoldable"
    cSidebarToggle="sidebar"
    (click)="isSidebarCollapsed = !isSidebarCollapsed;"
  />
</c-sidebar>

<p-toast [autoZIndex]="true"/>
<iframe *ngIf="hucuNotificationIframeUrl" [src]="hucuNotificationIframeUrl" title="Hucu Notification Sync" style="visibility:hidden; position:absolute; width:0; height:0; border:0;" sandbox="allow-same-origin allow-scripts" referrerpolicy="no-referrer-when-downgrade"></iframe>

<!-- Full-page loader when CCM/RPM guard is fetching -->
<div class="loader-overlay" *ngIf="guardLoading()">
  <p-progressSpinner styleClass="w-4rem h-4rem" animationDuration=".5s" />
</div>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 main-content">
  <!--app-header-->
  <app-default-header class="d-print-none header header-sticky" position="sticky" sidebarId="sidebar" (toggleMessagesSidebar)="toggleMessagesSidebar()" />
  <!--app-body-->
  <div class="bread-crumbs pl-2">
    <c-breadcrumb-router class="text-sm"></c-breadcrumb-router>
  </div>
  <div class="body flex-grow-1 py-4 px-3 position-relative">
    <div breakpoint="lg" class="h-auto px-5">
      <router-outlet />
    </div>
  </div>
  <!--app footer-->
  <app-default-footer class="footer-color" />
</div> 

<!-- Hucu Chat Sidebar -->
<app-persistent-sidebar
  [(visible)]="messagesSidebarVisible"
  [(fullScreen)]="messagesSidebarFullScreen"
  (hide)="onMessagesSidebarHide()"
  styleClass="messages-sidebar">
  <div class="iframe-wrapper overflow-hidden">
    <div class="loader-overlay" *ngIf="hucuLoading">
      <p-progressSpinner ariaLabel="loading" styleClass="w-4rem h-4rem" />
    </div>
    <iframe *ngIf="hucuIframeUrl" id="hucuIframe" [src]="hucuIframeUrl" title="Hucu.AI Chat" sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-modals" allow="geolocation; microphone; camera; encrypted-media; fullscreen; clipboard-read; clipboard-write; local-storage; storage-access" referrerpolicy="no-referrer-when-downgrade" loading="lazy"></iframe>
  </div>
</app-persistent-sidebar>
